// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","blue":"#00afef","header":"iQwiViI","logo":"_21rqkU2","code_block_container":"_1cWq6uh","code_block":"_13_Fhi3"};